$('.product-description-header').before('<p style="font-size: 12px; margin-bottom: 0;">⭐⭐⭐⭐⭐ Trusted by 24958+ Hangover FREE</p>');
$('<p>🏋️‍♀️ Provides essential nutrients. 🍎</p><p>💪 Improves overall health.</p><p>💤 Enhances well-being.</p><p>🚰 Supports bodily functions.</p>').insertAfter('.product-page--pricing');
$("#powrIframeLoader").hide();
$('#cartSlideoutWrapper > div.ajax-cart--bottom-wrapper > div.row').css('font-size', '10px');
$('<p>"<div>⭐⭐⭐⭐⭐</div><i>Worked like a charm! Took these to Vegas and was not hungover when any normal human would have been"<i></p>').insertBefore('.ajax-cart--bottom-wrapper');
$('<p>⭐⭐⭐⭐⭐ 4.5 Reviews</>p').insertBefore('.cart-item-product-title');

$(document).ready(function(){
    $("a[href*='https://www.mountsinai.org/").attr("rel", "nofollow");
    $("a[href*='https://www.mayoclinic.org/").attr("rel", "nofollow");
    $("a[href*='https://www.drinkhydrant.com/']").attr("rel", "nofollow");
    $("a[href='https://policies.google.com/']").attr("rel", "nofollow");
    $("a[href*='https://medlineplus.gov/ency/']").attr("rel", "nofollow");
    $("a[href*='https://www.medicalnewstoday.com/']").attr("rel", "nofollow");

    setTimeout(() => {
    $(".breadcrumb").prependTo("#main-body")
    }, "200");  
});

$(document).ready(function() {
    $("img").each(function() {
        var alt = $(this).attr("alt");
        
        if (!alt || alt.trim() === "") {
            var src = $(this).attr("src");
            var fileName = src.substring(src.lastIndexOf('/') + 1);
            
            fileName = fileName.replace(/\.[^/.]+$/, "");

            $(this).attr("alt", fileName);
        }
    });
});